<script lang="ts">
  import { FileText, Eye, ArrowUpRight } from "lucide-svelte";

  export interface TopPageItem {
    title: string;
    path: string;
    pv: number;
    uv: number;
    percentage: number;
  }

  interface Props {
    top_pages?: TopPageItem[];
    t: (key: string, params?: Record<string, any>) => string;
  }

  let { top_pages = [], t }: Props = $props();
</script>

<div class="rounded-xl border bg-card p-5 shadow-sm flex flex-col justify-between">
  <div>
    <!-- Header -->
    <div class="flex items-center justify-between mb-4">
      <div>
        <h3 class="text-sm font-semibold">{t('dashboard.charts.top_pages_title') || 'Top 热门页面'}</h3>
        <p class="text-xs text-muted-foreground">{t('dashboard.charts.top_pages_desc') || '近30天受访频次最高的页面 Top 5'}</p>
      </div>
      <div class="p-2 bg-primary/10 rounded-lg text-primary">
        <FileText class="size-4" />
      </div>
    </div>

    <!-- Content List -->
    {#if top_pages && top_pages.length > 0}
      <div class="space-y-3 mt-3">
        {#each top_pages as item, index}
          <div class="p-2.5 rounded-lg border bg-muted/20 hover:bg-muted/50 transition-colors">
            <div class="flex items-center justify-between gap-2 mb-1.5">
              <div class="flex items-center gap-2 overflow-hidden">
                <span class="flex items-center justify-center size-5 rounded-full text-[10px] font-bold shrink-0 {index === 0 ? 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/20' : index === 1 ? 'bg-slate-500/10 text-slate-600 dark:text-slate-400 border border-slate-500/20' : index === 2 ? 'bg-orange-500/10 text-orange-600 dark:text-orange-400 border border-orange-500/20' : 'bg-muted text-muted-foreground'}">
                  {index + 1}
                </span>
                <a 
                  href={item.path} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  class="text-xs font-medium truncate hover:text-primary transition-colors flex items-center gap-1 group"
                  title={item.title || item.path}
                >
                  <span class="truncate">{item.title || item.path}</span>
                  <ArrowUpRight class="size-3 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </div>
              <div class="flex items-center gap-3 text-xs shrink-0">
                <span class="font-bold">{item.pv.toLocaleString()} <span class="text-[10px] font-normal text-muted-foreground">PV</span></span>
              </div>
            </div>

            <!-- Progress Bar -->
            <div class="w-full bg-muted rounded-full h-1.5 overflow-hidden">
              <div 
                class="bg-primary h-1.5 rounded-full transition-all duration-500" 
                style="width: {Math.min(100, Math.max(0, item.percentage))}%"
              ></div>
            </div>
          </div>
        {/each}
      </div>
    {:else}
      <div class="flex h-48 items-center justify-center text-xs text-muted-foreground">
        {t('dashboard.charts.no_top_pages_data') || '暂无热门页面数据'}
      </div>
    {/if}
  </div>
</div>